export default class XeroContactSearchResult {
    id = '';
    contactId = '';  // Added to match backend field
    name = '';
    contactNumber = '';
    companyNumber = '';
    emailAddress = '';
    status = '';
}

export class XeroContactSearchResponse {
    contacts: XeroContactSearchResult[] = [];
    totalItems = 0;
    currentPage = 1;
    pageSize = 10;
}

export class XeroContactSearchRequest {
    searchTerm = '';
    page = 1;
    pageSize = 10;
}
